import { Link } from 'react-router-dom';

export default function HeroBanner() {
  return (
    <section className="relative w-full h-[420px] md:h-[600px] flex items-center justify-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Warm%20peach%20and%20cream%20abstract%20gradient%20background%20with%20soft%20organic%20shapes%20flowing%20curves%20minimalist%20elegant%20composition%20dreamy%20atmosphere%20clean%20modern%20aesthetic%20light%20airy%20feel&width=1600&height=900&seq=hero-bg-2025&orientation=landscape"
        alt="蜜桃网站背景"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/20 via-black/10 to-black/30"></div>

      <div className="relative z-10 w-full px-4 md:px-6 text-center">
        <p className="text-sm md:text-base text-white/80 mb-3 md:mb-4 font-body tracking-wider">
          甜蜜生活内容平台
        </p>
        <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-white mb-4 md:mb-6 leading-tight">
          发现你的
          <span className="text-primary-300">甜蜜生活</span>
          新体验
        </h1>
        <p className="text-sm md:text-lg text-white/70 max-w-2xl mx-auto mb-8 md:mb-10 leading-relaxed">
          蜜桃网站汇聚时尚、美食、情感、生活方式等多元内容，为年轻用户打造温暖而有趣的生活指南，让每一天都充满甜蜜与美好。
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-3 md:gap-4">
          <Link
            to="/category/lifestyle"
            className="inline-flex items-center gap-2 bg-primary-500 text-background-50 px-6 py-3 rounded-full text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
          >
            开始探索
            <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center"></i>
          </Link>
          <Link
            to="/about"
            className="inline-flex items-center gap-2 bg-white/15 backdrop-blur-sm text-white border border-white/30 px-6 py-3 rounded-full text-sm font-medium hover:bg-white/25 transition-colors whitespace-nowrap cursor-pointer"
          >
            了解更多
          </Link>
        </div>
      </div>
    </section>
  );
}